import {
  AdditionalInformationAction,
  AdditionalInformationState,
  AdditionalInformationType
} from "./@ŧypes/TiCardAdditionalInformationReducer";

export const TiCardAdditionalInformationInitialState: AdditionalInformationState =
  {
    type: AdditionalInformationType.Closed
  };

const TiCardAdditionalInformationReducer = (
  state: AdditionalInformationState,
  action: AdditionalInformationAction
): AdditionalInformationState => {
  switch (action?.type) {
    case AdditionalInformationType.Actor:
      if (
        state.type === AdditionalInformationType.Actor &&
        state.data.name === action.data.name
      ) {
        return {
          type: AdditionalInformationType.Closed
        };
      }
      return action;
    case AdditionalInformationType.Threat:
      if (state.type === AdditionalInformationType.Threat) {
        return {
          type: AdditionalInformationType.Closed
        };
      }
      return action;
    case AdditionalInformationType.Closed:
    default:
      return {
        type: AdditionalInformationType.Closed
      };
  }
};

export default TiCardAdditionalInformationReducer;
